import s from './Campaign.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Aside } from '../../components/Aside/Aside';
import { Helmet } from 'react-helmet-async';
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import titleImage from "../../assets/images/titleImage.png";
import React from "react";

const Campaign = () => {
  const breadcrumbItems = [
    {name: "ホーム", link: "/"},
    {name: "キャンペーン", link: "/campaign"},
    {name: "【最大5000円引き】複数割引キャンペーン！"}
  ];
  return (
    <>
          <Helmet>
        <title>【最大5000円引き】複数割引キャンペーン！</title>
        <meta property="og:title" content="【最大5000円引き】複数割引キャンペーン！" />
        <meta property="og:image" content={`${process.env.REACT_APP_URL}/og-image.png`} />
        <meta property="og:url" content={`${process.env.REACT_APP_URL}/multitour`} />
        <meta name="description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:description" content="自社ツアーやオプショナルツアーも予約できます！" />
        <meta property="og:type" content="article" />

      </Helmet>
      <div className={"row mt-3"}>
        <div className={"col-12"}>
          <Breadcrumb items={breadcrumbItems}/>
          <div className={s.titleContainer}>
            <h2><img className={s.titleImage} src={titleImage}/>【最大5000円引き】複数割引キャンペーン！</h2>
          </div>
        </div>
      </div>
      <div className={"row mt-3"}>
        <div className={"col-12 "}>
          <div className={s.card}>

              <table className={s.discountTable}>
              <tbody>
              <tr>
                <td>2件申し込み</td>
                <td>$15割引</td>
              </tr>
              <tr>
                <td>3件申し込み</td>
                <td>$25割引</td>
              </tr>
              <tr>
                <td>4件申し込み</td>
                <td>$50割引</td>
              </tr>
              </tbody>
            </table>
            <div className={s.images}>
              <img
                  src="https://dev.mightyaussie.com/wp-content/uploads/2024/02/%E8%A4%87%E6%95%B0%E5%89%B2%E5%BC%95%E3%83%AA%E3%82%B9%E3%83%88.png"
                  alt=""/>
              <img
                  src="https://dev.mightyaussie.com/wp-content/uploads/2024/02/%E8%A4%87%E6%95%B0%E5%89%B2%E5%BC%95%E3%83%AA%E3%82%B9%E3%83%88-2.png"
                  alt=""/>
            </div>
            <div className={s.warning}>
              <FontAwesomeIcon icon={faExclamationTriangle} className={s.warningIcon}/>
              <div>予約時備考欄に、〈複数割引 2ツアー/3ツアー/4ツアー希望〉とご記入ください。<br/>

                カートを分けてお申し込みされた方は、備考欄にすでにお申し込みのツアーの予約番号をご記入ください。
              </div>
            </div>
            <div className={s.notes}>
              <div>
                <i className="fas fa-info-circle"></i>
              </div>
              <div className={s.text}>
                <h3>注意事項</h3>
                <ul>
                  <li>
                    <strong className={s.under}>
                      <span style={{color: '#ff0000'}}>同一カートでの決済が対象です。</span>
                      <span>個別で決済された場合は対象外となります</span>
                    </strong>
                    <span>ので、その場合はLINEかメールでご連絡ください。</span>
                  </li>
                  <li>
                    <span>「複数割引希望」の方は、ご予約の際にご要望欄に</span>
                    <span style={{color: '#ff0000'}}>「複数割引希望」</span><span>とご記入ください。</span>
                  </li>
                  <li>
                    <span>複数割引は、</span>
                    <span style={{color: '#ff0000'}}>
              <strong className={s.under}><span>大人のみの適用</span></strong>
            </span>
                    <span>とさせていただきます。</span>
                  </li>
                  <li>
                    <strong className={s.under}>
                      <span>問い合わせ中にツアーの催行が始まってしまった場合は割引対象外となります</span>
                    </strong>
                    <span>のでご注意ください。</span>
                  </li>
                  <li>
            <span className={s.under}>
              上記の一覧以外のツアーは原則
            </span>
                    <strong className={s.under}><span>複数割引対象外</span></strong>です。
                  </li>
                  <li>
                    <strong className={s.under}><span>予約後48時間以内に開始されるものは対象外</span></strong>です。
                  </li>
                  <li>
                    <span>貸切オーダーメイドツアーやHPに掲載されていないツアー・各種チケットの手配は割引対象外です。</span>
                  </li>
                  <li>
                    <span>各種キャンペーンやタイムセールおよび家族料金など</span>
                    <strong className={s.under}><span>他キャンペーンとの併用はできません</span></strong>。
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>

    </>
  );
};

export default Campaign;
